import { compact, isUndefined, omitBy } from "lodash";
import { ICustomViewAttribute } from "src/c8-platform/type/customView";
import { C8AttributeKey } from "src/c8-platform/type/value";
import { ICustomViewOptions } from "./options/CustomViewOptions";

export type CustomViewIndexToKeyFunction = (index: string) => C8AttributeKey;

function mapKeys(keys: ICustomViewAttribute[], mapKey: CustomViewIndexToKeyFunction, forHiddenKeys: boolean, isPersonalizedView: boolean = false): ICustomViewAttribute[] {
	const results: ICustomViewAttribute[] = [];

	keys?.forEach((groupOrIndex) => {
		// handle attribute groups and save group key and attribute keys inside the group into the key map;
		// previously keys could be converted to a number, so change to string first 
		if (typeof groupOrIndex === "number") {
			groupOrIndex = String(groupOrIndex);
		}

		if (typeof groupOrIndex === "string") {
			const key = mapKey(groupOrIndex);
			if (key) {
				results.push(key);
			}
		} else {
			const { groupKey, keys, matrixTarget, name } = groupOrIndex;
			const mappedKeys = compact(keys.map(mapKey));
			const mappedGroupKey = mapKey(groupKey);

			if ((forHiddenKeys || mappedKeys.length || isPersonalizedView) && (!matrixTarget || mappedGroupKey)) {
				const params = omitBy({
					groupKey: mappedGroupKey,
					matrixTarget,
					name,
				}, isUndefined);

				results.push({
					keys: mappedKeys,
					...params,
				});
			}
		}
	});

	return results;
}

/** substitute keys for indices in custom view attribute keys value */
export function attributeKeysLoad(options: ICustomViewOptions, mapKey: CustomViewIndexToKeyFunction, isPersonalizedView: boolean = false): ICustomViewAttribute[] {
	return mapKeys(options.attributeKeys, mapKey, false, isPersonalizedView);
}

/** substitute keys for indices in custom view hidden keys value */
export function hiddenKeysLoad(options: ICustomViewOptions, mapKey: CustomViewIndexToKeyFunction): ICustomViewAttribute[] {
	return mapKeys(options.hiddenKeys, mapKey, true);
}
